import React from 'react'
import { connect } from 'react-redux'
import { chain } from 'lodash'
import { Segment, Header, Table, Button } from 'semantic-ui-react'
import styled from 'styled-components'

import DriverActions from '../../../reducers/driverReducer'
import ExpressActions from '../../../reducers/expressReducer'
import MapViewActions from '../../../reducers/mapViewReducer'

import SenderCell from '../components/SenderCell'
import DriverCell from '../components/DriverCell'
import OrderedAtCell from '../components/OrderedAtCell'
import StatusActionsCell from '../components/StatusActionsCell'
import ModalAssignDriver from '../../../components/orders/ModalAssignDriver'

const HeaderWrapper = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
`

class QueueOrders extends React.Component {
  state = {
    orderGroups: [],

    modalAssignVisible: false,
    assignDriverData: null,
  }

  componentDidMount() {
    const { connected, syncExpress, driversLoaded, syncDrivers } = this.props

    if (!connected) syncExpress()
    if (!driversLoaded) syncDrivers()
  }

  showMap = () => {
    const { orderGroups } = this.state
    const { setMapData } = this.props

    setMapData('same_day_order_guide', {
      groupedOrderKeys: orderGroups.flat(),
      createNewGroup: this.createNewGroup,
    })
  }

  createNewGroup = group => {
    const { orderGroups } = this.state

    this.setState({ orderGroups: orderGroups.concat(Array(group)) })
  }

  onRemove = (groupIndex, orderIndex) => {
    const { orderGroups } = this.state

    const newOrderGroups = Array.from(orderGroups)

    if (newOrderGroups[groupIndex].length > 1) {
      newOrderGroups[groupIndex].splice(orderIndex, 1)
    } else {
      newOrderGroups.splice(groupIndex, 1)
    }

    this.setState({ orderGroups: newOrderGroups })
  }

  showManualAssign = groupIndex => {
    const { orders } = this.props
    const { orderGroups } = this.state

    const orderKeys = orderGroups[groupIndex]
    const selectedOrders = orderKeys.map(orderKey => orders[orderKey])

    this.setState({
      modalAssignVisible: true,
      assignDriverData: selectedOrders,
    })
  }

  renderHeader = () => {
    const headers = ['Group No', 'Sender / Receiver', 'Driver / Location', 'Ordered At', 'Type / Status / Action', 'Remove']

    return (
      <Table.Row>
        <Table.Cell style={{ display: 'none' }} />
        {headers.map((header, index) => (
          <Table.HeaderCell
            style={index === 0 ? { borderLeft: 'none' } : {}}
            textAlign='center'
            key={header}
          >
            {header}
          </Table.HeaderCell>
        ))}
      </Table.Row>
    )
  }

  renderBody = (groupIndex, orderIndex, order, selectedOrders) => {
    const { orders } = this.props
    const { orderGroups } = this.state

    const orderCount = selectedOrders.length
    const courierType = order.courier_type || 'N/A'
    const delivererName = order.deliverer_name || 'N/A'
    const delivererTel = order.pending_driver || order.deliverer || 'N/A'

    const orderReceivers = chain(order.receivers)
      .map((receiver, key) => ({ ...receiver, key }))
      .orderBy('order_number')
      .value()

    const queueOrders = orderGroups[groupIndex].map(orderKey => orders[orderKey])

    return (
      <Table.Row key={order.id}>
        <Table.Cell style={{ display: 'none' }} />
        {
          orderIndex === 0 && (
            <Table.Cell
              textAlign="center"
              rowSpan={orderCount}
              style={{ borderleft: 'none' }}
            >
              {groupIndex + 1}
            </Table.Cell>
          )
        }

        <SenderCell
          id={order.id}
          receivers={orderReceivers}
          requestor={order.requestor}
          senderName={order.sender_name}
          senderPhone={order.sender_phone}
        />
        {orderIndex === 0 && (
          <DriverCell
            order={order}
            rowSpan={orderCount}
            queueOrders={queueOrders}
            receivers={orderReceivers}
            delivererName={delivererName}
            delivererTel={delivererTel}
            style={{ borderleft: 'none' }}
            showManualAssign={() => this.showManualAssign(groupIndex)}
          />
        )}
        <OrderedAtCell
          createdAt={order.created_at}
          deliveryAt={order.pending_driver_expired_at}
          pickupAt={order.pickup_eta}
          deliveredAt={order.updated_at}
          isDelivered={order.status === 'delivered'}
        />
        <StatusActionsCell status={order.status} updatedAt={order.updated_at} order={order} readOnly courierType={courierType} />

        <Table.Cell textAlign="center">
          <Button
            disabled={order.pending_e}
            color="red"
            size="mini"
            onClick={() => this.onRemove(groupIndex, orderIndex)}
          >
            Remove
          </Button>
        </Table.Cell>
      </Table.Row>
    )
  }

  render() {
    const { orders } = this.props
    const { orderGroups, modalAssignVisible, assignDriverData } = this.state

    const mainOrder = assignDriverData && assignDriverData[0]
    const queueOrders = (assignDriverData && assignDriverData.length > 1 && assignDriverData.slice(1)) || []

    return (
      <Segment color="black">
      <HeaderWrapper>
        <Header style={{ margin: 0 }} size="large">Queue Orders</Header>
        <div>
          <Button onClick={this.showMap}>
            Show Orders
          </Button>
        </div>
      </HeaderWrapper>

      <Table celled>
        <Table.Header>{this.renderHeader()}</Table.Header>
        <Table.Body>
          {
            orderGroups.length === 0 ? (
              <Table.Row key="no-result">
                <Table.Cell colSpan={8} textAlign="center">
                  No results
                </Table.Cell>
              </Table.Row>
            ) : (
              orderGroups.map((orderKeys, groupIndex) => {
                const selectedOrders = orderKeys.map(orderKey => orders[orderKey])

                return selectedOrders.map((order, orderIndex) => {
                  return this.renderBody(groupIndex, orderIndex, order, selectedOrders)
                })
              })
            )
          }
        </Table.Body>
      </Table>

      <ModalAssignDriver
        isExpressOrder
        action="manual"
        visible={modalAssignVisible}
        order={mainOrder}
        queueOrders={queueOrders}
        onCancel={() => this.setState({ modalAssignVisible: false, assignDriverData: null })}
      />

    </Segment>
    )
  }
}

const mapState = ({ express, drivers }) => ({
  orders: express.sameDayOrders,
  driversLoaded: drivers.driverLoaded,
})

const mapDispatch = {
  setMapData: MapViewActions.setMapData,
  syncDrivers: DriverActions.syncDrivers,
  syncExpress: ExpressActions.syncExpress,
}

export default connect(mapState, mapDispatch)(QueueOrders)


// WEBPACK FOOTER //
// ./src/containers/express/queueOrders/index.js